import { render, staticRenderFns } from "./createBKCust2Family.vue?vue&type=template&id=f1ea067e&scoped=true"
import script from "./createBKCust2Family.vue?vue&type=script&lang=js"
export * from "./createBKCust2Family.vue?vue&type=script&lang=js"
import style0 from "./createBKCust2Family.vue?vue&type=style&index=0&id=f1ea067e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ea067e",
  null
  
)

export default component.exports